import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  dialogCalendarOpen: {
    [theme.breakpoints.down("sm")]: {
      borderRadius: "0px"
    }
  },
  dialogContentCalendarOpen: {
    display: "flex",
    overflow: "hidden",
    [theme.breakpoints.down("xs")]: {
      width: "100vw"
    },
    [theme.breakpoints.up("sm")]: {}
  },
  selectedDateRangeButton: {
    display: "flex",
    color: theme.palette.secondary.main,
    textTransform: "initial",
    fontSize: "16px"
  },
  dateRangeButton: {
    whiteSpace: "nowrap"
  },
  selectedDateRangeIcon: {},
  selectedDateRangeIconOpened: {},
  listItem: {
    padding: "0"
  },
  listItemText: {
    fontSize: "14px"
  },
  listItemDateText: {
    fontSize: "14px",
    color: theme.palette.secondary.dark
  },
  listItemLeftIcon: {
    minWidth: "32px"
  },
  listItemRightIcon: {
    minWidth: "44px",
    justifyContent: "flex-end"
  },
  listItemIconCheck: {
    width: "20px",
    height: "20px",
    backgroundColor: "#fff",
    padding: "4px",
    marginRight: "12px",
    borderRadius: "50%",
    boxShadow: "0 0 4px 0 #ccc",
    border: "1px solid #bbb",
    "& path": {
      display: "none"
    }
  },
  listItemIconCheckSelected: {
    backgroundColor: theme.palette.secondary.main,
    borderColor: theme.palette.text.primary,
    "& path": {
      display: "initial"
    }
  },
  listItemIconDate: {
    width: "20px",
    height: "20px",
    marginRight: "12px",
    fill: theme.palette.secondary.dark
  },
  listItemIconEdit: {
    width: "20px",
    height: "20px",
    fill: theme.palette.text.primary
  },
  listItemButton: {
    justifyContent: "flex-start",
    padding: "16px",
    textTransform: "initial"
  },
  calendar: {
    flex: "auto",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    paddingBottom: "60px",
    [theme.breakpoints.up("md")]: {
      paddingBottom: "80px"
    }
  },
  calendarContainer: {
    display: "flex",
    flex: "auto",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column"
    }
  },
  selectedDates: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: theme.palette.secondary.main,
    padding: "12px",
    [theme.breakpoints.up("sm")]: {
      flexDirection: "column"
    }
  },
  selectedDatesTitle: {
    fontFamily: "SuisseIntlMedium",
    textTransform: "uppercase",
    marginBottom: "12px"
  },
  selectedDatesContent: {
    flex: "auto",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    [theme.breakpoints.down("xs")]: {
      alignItems: "center"
    }
  },
  selectedDatesItem: {
    display: "flex",
    flexWrap: "wrap",
    width: "152px"
  },
  selectedDatesItemTitle: {
    width: "40px"
  },
  selectedDatesItemValue: {
    flex: "auto",
    fontFamily: "SuisseIntlMedium"
  },
  datePickers: {
    display: "flex",
    alignItems: "center",
    overflow: "auto",
    [theme.breakpoints.only("sm")]: {
      padding: "20px"
    },
    "& .rdrDefinedRangesWrapper": {
      display: "none"
    },
    "& .rdrCalendarWrapper": {
      fontSize: "13px"
    },
    "& .rdrMonths": {
      [theme.breakpoints.down("sm")]: {
        flexDirection: "column"
      }
    },
    "& .rdrMonth": {
      padding: "8px",
      width: "296px",
      height: "354px"
    },
    "& .rdrMonth .rdrMonthName": {
      padding: "8px"
    },
    "& .MuiPickersDay-daySelected": {
      backgroundColor: theme.palette.secondary.dark
    },
    "& .rdrWeekDays .rdrWeekDay": {
      flexBasis: "initial",
      width: "40px",
      height: "40px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    "& .rdrDay": {
      width: "40px",
      height: "40px",
      margin: "2px 0"
    },
    "& .rdrDay:not(.rdrDayPassive) .rdrDayNumber span": {
      color: theme.palette.text.primary
    },
    "& .rdrDay.rdrDayToday:not(.rdrDayPassive) .rdrDayNumber": {
      border: `1px solid ${theme.palette.text.primary}`
    },
    "& .rdrDay.rdrDayToday .rdrDayNumber span:after": {
      content: "none"
    },
    "& .rdrDay .rdrDayNumber": {
      top: "1px",
      bottom: "1px",
      left: "1px",
      right: "1px",
      borderRadius: "50%"
    },
    "& .rdrDay .rdrInRange": {
      top: "0px",
      bottom: "0px",
      left: "0px",
      right: "0px"
    },
    "& .rdrDay .rdrStartEdge": {
      left: "0px",
      top: "0px",
      bottom: "0px",
      right: "0px",
      borderTopLeftRadius: "50%",
      borderBottomLeftRadius: "50%"
    },
    "& .rdrDay .rdrEndEdge": {
      top: "0px",
      bottom: "0px",
      left: "0px",
      right: "0px",
      borderTopRightRadius: "50%",
      borderBottomRightRadius: "50%"
    },
    "& .rdrDay .rdrDayInPreview": {
      top: "0px",
      bottom: "0px",
      left: "0px",
      right: "0px"
    },
    "& .rdrDay.rdrDayStartOfWeek .rdrEndEdge": {
      borderTopLeftRadius: "50%",
      borderBottomLeftRadius: "50%"
    },
    "& .rdrDay.rdrDayStartOfMonth .rdrEndEdge": {
      borderTopLeftRadius: "50%",
      borderBottomLeftRadius: "50%"
    },
    "& .rdrDay.rdrDayStartOfWeek .rdrDayInPreview": {
      borderTopLeftRadius: "50%",
      borderBottomLeftRadius: "50%"
    },
    "& .rdrDay.rdrDayStartOfMonth .rdrDayInPreview": {
      borderTopLeftRadius: "50%",
      borderBottomLeftRadius: "50%"
    },
    "& .rdrDay.rdrDayStartOfWeek .rdrInRange": {
      borderTopLeftRadius: "50%",
      borderBottomLeftRadius: "50%"
    },
    "& .rdrDay.rdrDayStartOfMonth .rdrInRange": {
      borderTopLeftRadius: "50%",
      borderBottomLeftRadius: "50%"
    },
    "& .rdrDay.rdrDayStartOfWeek .rdrDayEndPreview": {
      borderTopLeftRadius: "50%",
      borderBottomLeftRadius: "50%"
    },
    "& .rdrDay.rdrDayStartOfMonth .rdrDayEndPreview": {
      borderTopLeftRadius: "50%",
      borderBottomLeftRadius: "50%"
    },
    "& .rdrDay.rdrDayEndOfWeek .rdrStartEdge": {
      borderTopRightRadius: "50%",
      borderBottomRightRadius: "50%"
    },
    "& .rdrDay.rdrDayEndOfMonth .rdrStartEdge": {
      borderTopRightRadius: "50%",
      borderBottomRightRadius: "50%"
    },
    "& .rdrDay.rdrDayEndOfWeek .rdrInRange": {
      borderTopRightRadius: "50%",
      borderBottomRightRadius: "50%"
    },
    "& .rdrDay.rdrDayEndOfMonth .rdrInRange": {
      borderTopRightRadius: "50%",
      borderBottomRightRadius: "50%"
    },
    "& .rdrDay.rdrDayEndOfWeek .rdrDayInPreview": {
      borderTopRightRadius: "50%",
      borderBottomRightRadius: "50%"
    },
    "& .rdrDay.rdrDayEndOfMonth .rdrDayInPreview": {
      borderTopRightRadius: "50%",
      borderBottomRightRadius: "50%"
    },
    "& .rdrDay.rdrDayEndOfWeek .rdrDayStartPreview": {
      borderTopRightRadius: "50%",
      borderBottomRightRadius: "50%"
    },
    "& .rdrDay.rdrDayEndOfMonth .rdrDayStartPreview": {
      borderTopRightRadius: "50%",
      borderBottomRightRadius: "50%"
    },
    "& .rdrDay .rdrDayStartPreview": {
      top: "0px",
      bottom: "0px",
      left: "0px",
      right: "0px",
      borderTopLeftRadius: "50%",
      borderBottomLeftRadius: "50%"
    },
    "& .rdrDay .rdrDayEndPreview": {
      top: "0px",
      bottom: "0px",
      left: "0px",
      right: "0px",
      borderTopRightRadius: "50%",
      borderBottomRightRadius: "50%"
    },
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column"
    }
  },
  calendarButtons: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "12px",
    position: "absolute",
    bottom: "0px",
    left: "0px",
    right: "0px",
    [theme.breakpoints.down("sm")]: {
      boxShadow: "0 0 6px 0 rgba(0, 0, 0, 0.2)"
    },
    [theme.breakpoints.up("md")]: {}
  },
  calendarSaveButton: {
    color: theme.palette.secondary.dark
  }
}));
